const promoIdentifierConfig = {
	text: {
		size: { xxs: 'm2', m: 'm1', l: '1' },
	},
	style: {
		backgroundColor: {
			black: 'var(--color-global-black)',
			brand: 'var(--color-brand-mid)',
			featured: 'var(--color-functional-panelDark)',
		},
		textColor: {
			black: 'var(--color-base-white)',
			brand: 'var(--color-base-white)',
			featured: 'var(--color-global-grey900)',
		},
	},
};

const { text, style } = promoIdentifierConfig;

export default promoIdentifierConfig;
export { text, style };
